import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { UnauthenticatedHandler } from '../unauthenticated-handler';
import _ from 'lodash';
import { UserCenterService } from '@patsnap-utils/biz';
import { isInIframe } from '../../../utils/in-iframe';
import { Logger } from '@patsnap/tahiti-core';
import { AiAgentEnvService } from '@telecom/shared/services/ai-agent-env-service/ai-agent-env-service';
import { AnonymousError } from '@telecom/shared/startup';

function stopper() {
    if (window.location.search.indexOf('noraven') > -1) {
        throw new Error('Local stop redirect');
    }
}

@injectable()
export class UnauthenticatedHandlerImpl implements UnauthenticatedHandler {
    constructor(
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(AiAgentEnvService)
        private readonly _aiAgentEnvService: AiAgentEnvService,
    ) { }

    handle(error: Error): void {
        // 现在开始支持游客版, 不跳转登录,需要主动抛出一个匿名用户错误
        throw new AnonymousError();
        return;
        if (this._aiAgentEnvService.isInAiAgentFlow) {
            this._logger.warn('运行在 AI Agent Flow 中，不进行 401 重定向');
            return;
        }
        else if (isInIframe()) {
            this._logger.warn('运行在 iframe 中，调用父级页面 401 策略');
            this._callIframeParent();
        }
        else {
            this._logger.warn('运行在非 iframe 中，进行 401 重定向');
            stopper();
            const errorCode = _.get(error, 'errcode', 39999);
            const logoutUrl = UserCenterService.createLogoutHref(true, { errorCode });
            window.location.replace(logoutUrl);
        }
    }


    /**
     * 调用iframe父级页面的方法
     */
    private _callIframeParent() {
        if (isInIframe()) {
            window.parent.postMessage(JSON.stringify({ type: 'unauthenticated' }), '*');
        }
    }
}


